export default __webpack_public_path__ + "static/media/keyButton.12399797.png";